import { render, staticRenderFns } from "./PortfolioModal.vue?vue&type=template&id=7722042a&scoped=true"
import script from "./PortfolioModal.vue?vue&type=script&lang=js"
export * from "./PortfolioModal.vue?vue&type=script&lang=js"
import style0 from "./PortfolioModal.vue?vue&type=style&index=0&id=7722042a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7722042a",
  null
  
)

export default component.exports